import findAllFor from '../filters/find-all-for';

const getHideConstraintForElement = (element) => {
  const constraints = findAllFor(element);
  const hideableConstraints = constraints.filter((constraint) => 'hideable' in constraint);

  if (!hideableConstraints.every((constraint) => constraint.hideable)) {
    return null;
  }

  return hideableConstraints.find((constraint) => constraint.hideable);
};

export default getHideConstraintForElement;
